// extracted by mini-css-extract-plugin
export default {"RoomTypeModal__closeButton":"RoomMediaModal_RoomTypeModal__closeButton__SCVB4","RoomTypeModal__modalWrapper":"RoomMediaModal_RoomTypeModal__modalWrapper__5OmQz"};